import { render } from "./NewLooseThoughts.vue?vue&type=template&id=35307555"
import script from "./NewLooseThoughts.vue?vue&type=script&lang=js"
export * from "./NewLooseThoughts.vue?vue&type=script&lang=js"

import "./NewLooseThoughts.vue?vue&type=style&index=0&id=35307555&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__